import React from "react"

import { RichtextStoryblok } from "@/components/storyblok/component-types"
import UbRichText from "@/components/storyblok/UbRichText"

interface NewsletterCheckboxProps {
  defaultChecked?: boolean
  disabled?: boolean
  text: RichtextStoryblok | undefined
}

export default function NewsletterCheckbox(props: NewsletterCheckboxProps) {
  return (
    <div className="flex flex-row items-start gap-2 text-xs">
      <input
        id={"newsletter"}
        aria-label={"newsletter"}
        className={"checked:bg-primary hover:checked:bg-primary focus:ring-0"}
        name={"newsletter"}
        value={"true"}
        type="checkbox"
        defaultChecked={props.defaultChecked}
        disabled={props.disabled}
      />
      <label htmlFor={"newsletter"}>
        <div className={"flex flex-col gap-2"}>
          {props.text && (
            <div>
              <UbRichText blok={{ content: props.text, _uid: "", component: "ub_rich_text" }} />
            </div>
          )}
        </div>
      </label>
    </div>
  )
}
